import { render, staticRenderFns } from "./CurrentAccounts.vue?vue&type=template&id=d653380c"
import script from "./CurrentAccounts.vue?vue&type=script&lang=js"
export * from "./CurrentAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports